import { z } from 'zod';
import { AgentRunStatusSchema } from './agent-types';
import type { AgentRunStep } from './agent-types';
import { AgentRunIdSchema, SessionIdSchema } from './entity-ids';

export const SessionEventTypeSchema = z.enum([
  'user_message',
  'assistant_message',
  'error',
]);

export const SessionEventSchema = z.object({
  sessionId: SessionIdSchema.nullable(),
  type: SessionEventTypeSchema,
  content: z.string(),
  metadata: z.unknown().optional(),
  timestamp: z.number(),
  sequence: z.number(),
});
export type SessionEvent = z.infer<typeof SessionEventSchema>;

export const ActiveAgentRunSchema = z.object({
  id: AgentRunIdSchema,
  status: AgentRunStatusSchema,
  createdAt: z.string(),
  heartbeatAt: z.string().nullable(),
});
export type ActiveAgentRun = z.infer<typeof ActiveAgentRunSchema>;

export const SessionDocumentOriginSchema = z.enum(['created', 'opened']);
export type SessionDocumentOrigin = z.infer<typeof SessionDocumentOriginSchema>;

/** A document a chat created or opened; re-mounted on every run. */
export const SessionDocumentSummarySchema = z.object({
  documentId: z.string(),
  kind: z.enum(['deck', 'workbook']),
  name: z.string(),
  origin: SessionDocumentOriginSchema,
  createdAt: z.string(),
});
export type SessionDocumentSummary = z.infer<
  typeof SessionDocumentSummarySchema
>;

/** A file the agent kept in a home chat's workspace (under assets/). */
export const SessionFileSummarySchema = z.object({
  path: z.string(),
  name: z.string(),
  size: z.number(),
  updatedAt: z.string(),
});
export type SessionFileSummary = z.infer<typeof SessionFileSummarySchema>;

export interface SessionState {
  spaceId: string;
  /** Primary document; null for home chats. */
  documentId: string | null;
  events: SessionEvent[];
  steps: AgentRunStep[];
  activeRuns?: ActiveAgentRun[];
  documents?: SessionDocumentSummary[];
}

export interface SessionListItem {
  id: string;
  spaceId: string;
  /** Primary document; null for home chats. */
  documentId: string | null;
  title: string;
  lastActivityAt: string;
  archivedAt: string | null;
  hasActiveRun: boolean;
}
